import React, { useMemo, useState } from "react";
import { isEmpty, isNil } from "lodash";
import { Box } from "@mui/material";

import useAssociationUtils from "../../components/associations/hooks/useAssociationUtils";
import Txt from "../../components/typography/Txt";
import InlineEditableLoanFilesTable from "./InlineEditableLoanFilesTable";
import { isDocHidden } from "../../_src_shared/utils/functions/isDocHidden";
import Flx from "../../components/layout/Flx";
import SearchInput from "../../components/inputs/SearchInput";
import SearchInputLight from "../../components/inputs/SearchInputLight";

const LoanBorrowerAssociatedFilesTable = ({
  borrower,
  loan,
  showSearch = true,
}) => {
  const { getAssociationDocumentsByBorrowerId } = useAssociationUtils();
  const [quickFilter, setQuickFilter] = useState(null);
  const borrowerFiles = useMemo(() => {
    return (
      getAssociationDocumentsByBorrowerId(loan, borrower?._id) || []
    ).filter((f) => !isDocHidden(f));
  }, [loan, borrower, getAssociationDocumentsByBorrowerId]);

  if (isEmpty(borrowerFiles) || isNil(loan)) {
    return (
      <Box
        sx={{
          py: 2,
          px: 2,
          // background: "#FAFAFA",
          // borderRadius: 1,
          // ml: -0.5,
          // mt: 0.5,
        }}
      >
        <Txt sx={{ opacity: 0.85 }} secondary>
          No files associated with borrower.
        </Txt>
      </Box>
    );
  }

  // Inline-editable filename + doc type (category & type) with preview.
  return (
    <Flx column>
      {showSearch && (
        <Box sx={{ px: 2, borderBottom: "0.5px solid rgba(0, 0, 0, 0.08)" }}>
          <SearchInputLight
            fullWidth
            sx={{ fontSize: "11px", width: "100%" }}
            value={quickFilter}
            onChange={setQuickFilter}
          />
        </Box>
      )}
      <InlineEditableLoanFilesTable
        files={borrowerFiles}
        loanId={loan?._id}
        quickFilter={quickFilter}
        metaField="docType"
      />
    </Flx>
  );
};

export default LoanBorrowerAssociatedFilesTable;
